export const localFiltersDefaultCookieName = 'defaultLocalFilters';
